import { render, staticRenderFns } from "./SurveySetting.vue?vue&type=template&id=3a36edf8&scoped=true"
import script from "./SurveySetting.vue?vue&type=script&lang=js"
export * from "./SurveySetting.vue?vue&type=script&lang=js"
import style0 from "./SurveySetting.vue?vue&type=style&index=0&id=3a36edf8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a36edf8",
  null
  
)

export default component.exports